import { Component, Inject, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { FormControl } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../providers/shared.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-booking-list-for-invoice-merge',
  templateUrl: './booking-list-for-invoice-merge.component.html',
  styleUrls: ['./booking-list-for-invoice-merge.component.scss']
})
export class BookingListForInvoiceMergeComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton!: ElementRef;
  public serviceListData: ServiceList = new ServiceList();
  public bookingsData: any = []
  isDiscount!: boolean;
  isShop: boolean = false
  isHome: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  entityHash: string = '';
  bookingType: string = '';
  hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public page: number = 1;
  serviceList: any[] = [];
  selectedBookingList: any[] = [];
  datalength!: number
  toShowTemplate: boolean = true
  loading: boolean= false
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderService: LoaderServiceService,
    public dialog: MatDialogRef<BookingListForInvoiceMergeComponent>,
    private renderer: Renderer2, private el: ElementRef
  ) {}
  removeAsset() {
    this.serviceListData.imgUrl = '';
    this.assetList = [];
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data);
      this.entityHash = data.entityHash
      this.bookingType = data.bookingType ? data.bookingType : data.serviceType

      
    })
    this.loading = true
    this._apiService.getEntitySlotsInfo2(this.entityHash, this.bookingType, '0' )
    
    
    console.log(this.parentData.data);
  

    
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log('Response', resData);
     
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_SLOTS_INFO2){
        this.bookingsData = []
        if(resData.result){
          console.log(resData);
         
          resData.result.forEach((element:any) => {
            if(element.bookingStatus == 4 && element.hash_id != this.parentData.data){
              this.bookingsData.push(element)
            }
           
          });
          this.bookingsData = this.sortObjectsDescendingByBookingNumber(this.bookingsData)
  
          this.bookingsData.forEach((element:any) => {
          element.selected = false
         if(element.customerInfo){
            element.customerInfo = JSON.parse(element.customerInfo)
            element.customerName = element.customerInfo.name
            element.customerPhone = element.customerInfo.phone
          
         }
          
            if(element.serviceInfo && element.serviceInfo != 'null'){
          
                element.servicesArray = ''
                element.serviceInfo.forEach((item:any, index:any) => {
                  element.servicesArray += item.serviceName;
                  
                  // Check if the current element is not the last one
                  if (index < element.serviceInfo.length - 1) {
                      element.servicesArray += ', ';
                  }
              });
          
            }else if(!element.serviceInfo || element.serviceInfo == 'null'){
              element.servicesArray = ''
            }
          
              
              if(element.paymentStatus === 0 || !element.paymentStatus){
                element.paymentStat = 'Due'
              }
              else if(element.paymentStatus == 1){
                element.paymentStat = 'Done'
              }
              else if(element.paymentStatus == 2){
                element.paymentStat = 'Payment in progress'
              }
              else if(element.paymentStatus == 3){
                element.paymentStat = 'Error in payment'
              }
              else {
                element.paymentStat = 'N/A'
              }
              
            // }
            
            
            if(element.bookingStartTime && element.bookingStartTime!= null){
               element.bookingStartTime =  element.bookingStartTime.slice(0,5)
            }
           if(element.bookingEndTime && element.bookingEndTime!=null){
            element.bookingEndTime = element.bookingEndTime.slice(0,5)
           }
             
            if(element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2 ){
              element.bookingStat = 'New booking'
            }else if(element.bookingStatus == 3){
              element.bookingStat = 'Under process'
            }else if(element.bookingStatus == 4){
              element.bookingStat = 'Completed'
            }else if(element.bookingStatus == 5){
              element.bookingStat = 'Booking confirmed'
            }
            else if(element.bookingStatus == 6){
              element.bookingStat = 'Cancelled by User'
            }
            else if(element.bookingStatus == 7){
              element.bookingStat = 'Assigned'
            }
            else if(element.bookingStatus == 8){
              element.bookingStat = 'Cancelled by service provider'
            }
            else if(element.bookingStatus == 9){
              element.bookingStat = 'Partially Complete'
            }
  
  
            if(!element.employeeName){
              element.employeeName = 'N/A'
            }
  
  
          })
        }
      


        this.loading=false
        this.loaderService.showLoader = false;
        console.log( this.bookingsData);
        
      }
      else if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS){
        if (resData.result) {
          this.loaderService.showLoader = false
          const closeButton = this.el.nativeElement.querySelector('button[mat-dialog-close]');
    
          if (closeButton) {
            this.renderer.selectRootElement(closeButton).click();
          }
        } 
        
      }

      else if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE){
        if (resData.result) {
          this.loaderService.showLoader = false
          const closeButton = this.el.nativeElement.querySelector('button[mat-dialog-close]');
    
          if (closeButton) {
            this.renderer.selectRootElement(closeButton).click();
          }
        } 
        
      }
    });
  }
  sortObjectsDescendingByBookingNumber(array: any) {
    return array.slice().sort((a:any, b:any) => parseInt(b.appointment_no) - parseInt(a.appointment_no));
  }
  change(event:any){
    console.log(event);
    if(event.checked == true && event.source.value == 'home'){
      this.isHomeSpecific = true
      this.serviceListData.homeStatus = 1
    } if(event.checked == true && event.source.value == 'shop'){
      this.isShopSpecific = true
      this.serviceListData.shopStatus = 1
    } if(event.checked == false && event.source.value == 'home'){
      this.isHomeSpecific = false
      this.serviceListData.homeStatus = 0
      this.serviceListData.home_rate = null
      this.serviceListData.homeDiscountedPrice = null
    }if(event.checked == false && event.source.value == 'shop'){
      this.isShopSpecific = false
      this.serviceListData.shopStatus = 0
      this.serviceListData.shop_rate = null
      this.serviceListData.shopDiscountedPrice = null
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.serviceListData.discountStatus = 1
    }if(event.target.value == 'not-applicable'){
      this.serviceListData.discountStatus = 0
      this.serviceListData.discountAmount = null
      this.serviceListData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.serviceListData.homeDiscountedPrice = null
      this.serviceListData.shopDiscountedPrice = null
    }

  }

  discType(event:any){
    if(event.target.value == 'percent' ){
      this.serviceListData.discountType = 1
    }if(event.target.value == 'amount'){
      this.serviceListData.discountType = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
           this.serviceList = []
           this.page = 1
  }

  onPost() {
    // console.log('Data', this.serviceListData);
 
    console.log(this.editMode);
    if (!this.editMode) {
      // this.serviceListData['hash_id'] = undefined;
    }

    if(this.serviceListData.discountType == 1){
      if(this.serviceListData.homeStatus != 0){
        this.serviceListData.homeDiscountedPrice = +(this.serviceListData.home_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.home_rate).toFixed(2)
      }
      if(this.serviceListData.shopStatus != 0){
        this.serviceListData.shopDiscountedPrice = +(this.serviceListData.shop_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.shop_rate).toFixed(2)
      }
      
    }else if(this.serviceListData.discountType == 2){
      if(this.serviceListData.homeStatus != 0){
        this.serviceListData.homeDiscountedPrice = this.serviceListData.home_rate - this.serviceListData.discountAmount
      }
      if(this.serviceListData.shopStatus != 0){
        this.serviceListData.shopDiscountedPrice = this.serviceListData.shop_rate - this.serviceListData.discountAmount
      }
      
     
    }

    if(this.serviceListData.homeStatus == 0){
      this.serviceListData.home_rate = 0
    }
    
    if(this.serviceListData.shopStatus == 0){
      this.serviceListData.shop_rate = 0
    }
    if(this.serviceListData.discountStatus == 0){
      this.serviceListData.discountAmount = 0
      this.serviceListData.homeDiscountedPrice = 0
      this.serviceListData.shopDiscountedPrice = 0
    }

    if(this.serviceListData.home_rate == '-'){
      this.serviceListData.home_rate = 0
    }
    if(this.serviceListData.shop_rate == '-'){
      this.serviceListData.shop_rate = 0
    }
    if(this.serviceListData.homeDiscountedPrice == '-'){
      this.serviceListData.homeDiscountedPrice = 0
    }
    if(this.serviceListData.shopDiscountedPrice == '-'){
      this.serviceListData.shopDiscountedPrice = 0
    }


    Object.keys(this.serviceListData).forEach(key => {
      if ((this.serviceListData as any)[key] === null) {
        delete (this.serviceListData as any)[key];
      }
    });
  
 let bodydata = {
  serviceTypeInfo: this.serviceListData
 }
    console.log('updated data', bodydata);
    this._apiService.addUpdateServiceType(bodydata, this.entityHash)
    // this.dialog.close();
    //   setTimeout(() => {
    //     this.sharedService.sendClickEvent();
    //   }, 2000);
    // this._apiService.updateBuisnessPromotion({
    //   promotionInfo: this.serviceListData,
    // });
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }
  mergedInvoicesData:any = []
  selectBooking(item:any){
    
    item.selected = !item.selected
    if(item.selected){
      this.selectedBookingList.push(item)
    }
    else if(!item.selected){
      const index = this.selectedBookingList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      this.selectedBookingList.splice(index,1)
    }
    console.log(this.selectedBookingList);
    

  }

  onSelectNext(){
    this.mergedInvoicesData = []
    this.mergedInvoicesData = [{
      appointment_hash_id: this.parentData.data,
      is_primary: 1,
      creation_date: this.formatDateString(new Date())
    }]
    this.selectedBookingList.forEach(element => {
      let data = {
        appointment_hash_id: element.hash_id,
        is_primary: 0
      }
      this.mergedInvoicesData.push(data)
    });

    console.log(this.mergedInvoicesData);
    
    this.loaderService.showLoader = true
    if(this.parentData.isEntityForeign == '0'){
      this._apiService.addEditEntityInvoice(this.mergedInvoicesData)

    }
    else if(this.parentData.isEntityForeign == '1'){
      this._apiService.addEditInternationalEntityInvoice(this.mergedInvoicesData)
    }

  }


  formatDateString(datestr: Date): string {
    const now = new Date(datestr);
    
    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Ensures 24-hour format
    };
  
    const formattedDate = new Intl.DateTimeFormat('en-CA', options).formatToParts(now);
  
    let year = '', month = '', day = '', hours = '', minutes = '', seconds = '';
  
    formattedDate.forEach(part => {
      if (part.type === 'year') year = part.value;
      if (part.type === 'month') month = part.value;
      if (part.type === 'day') day = part.value;
      if (part.type === 'hour') hours = part.value;
      if (part.type === 'minute') minutes = part.value;
      if (part.type === 'second') seconds = part.value;
    });
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  back(){
    this.toShowTemplate=true

   
  }

  seeMore(){
    this.page +=  1;
    this._apiService.getServiceTemplates(this.page)
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getServiceTemplates(this.page)
  }

}

